import { useQuery, useMutation } from "@tanstack/react-query";
import { GetUserData } from "common/service/CommonService";
import { VolunteerTestRequest } from "modules/Volunteer/MasterVolunteer/helper/volunteer.types";
import { volunteerTestApiService } from "./volunteerTestApiService";

export const useVolunteerTest = ({
  searchtext = null,
  currentpage,
  pagesize,
  volunteerid,
  studyid,
  enabled=true
}: VolunteerTestRequest) => {
  const SelectAllVolunteerTestResult = useQuery({
    queryKey: [
      "volunteer-alcohol-test-result",
      volunteerid,
      currentpage,
      pagesize,
      searchtext,
      studyid,
    ],
    queryFn: () =>
      volunteerTestApiService.getAllVolunteerTest({
        volunteerid,
        studyid,
        searchtext,
        status: "A",
        currentpage,
        pagesize,
      }),
    enabled: enabled && !!(volunteerid),
  });

  const InsertMutation = useMutation({
    mutationFn: (payload: any) =>
      volunteerTestApiService.insertVolunteerTest(payload),
  });

  const UpdateMutation = useMutation({
    mutationFn: (payload: any) =>
      volunteerTestApiService.updateVolunteerTest(payload),
  });

  const DeleteMutation = useMutation({
    mutationFn: (payload: any) =>
      volunteerTestApiService.deleteVolunteerTest(payload),
  });

   const VolunteerTestCount = useQuery({
    queryKey: [
      "volunteer-test-count",
      volunteerid,
      studyid,
    ],
    queryFn: () =>
      volunteerTestApiService.getVolunteerTestCount({
        volunteerid,
        studyid,
        status:'A'
      }),
    enabled: enabled && !!(volunteerid),
  });


  return {
    SelectAllVolunteerTestResult,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
    VolunteerTestCount
  };
};
